module.exports = __webpack_public_path__ + "resources/img/img_rancher_en.dae6a6a202acf4f7ee62f3ab2c3e046e.png";